import { expenseRepository } from '@webapp/modules/expense/data-access/repositories/ExpenseRepository'
import { SaveExpenseDraftUseCase } from './SaveExpenseDraftUseCase'

export const saveExpenseDraftUseCase = new SaveExpenseDraftUseCase(
  expenseRepository
)

export { SaveExpenseDraftUseCase } from './SaveExpenseDraftUseCase'
